export const FIRESTORE_JOBS_COLLECTION = "Jobs";
export const FIRESTORE_DRAFT_JOBS_COLLECTION = "DraftJobs";
export const FIRESTORE_SAVED_JOBS_COLLECTION = "SavedJobs";
export const FIRESTORE_VIEWS_COLLECTION = "Views";
export const FIRESTORE_USERS_COLLECTION = "Users";
export const FIRESTORE_REQUEST_DELETE_ACCOUNTS_COLLECTION =
  "RequestDeleteAccounts";
export const FIRESTORE_APP_MODE_COLLECTION = "AppMode";
export const FIRESTORE_JOB_POST_ORDER_COLLECTION = "JobPostOrders";
export const FIRESTORE_ERRORS_COLLECTION = "Errors";
export const FIRESTORE_COOKIE_CONSENT_RECORD_COLLECTION = "CookieConsentRecord";
export const FIRESTORE_JOBS_STATUS_LOG_COLLECTION = "JobsStatusLog";
export const FIRESTORE_FEATURED_COMPANY_LOGOS_COLLECTION =
  "FeaturedCompanyLogos";
export const FIRESTORE_COUPONS_COLLECTION = "Coupons";
export const FIRESTORE_COMPANIES_COLLECTION = "Companies";
export const FIRESTORE_TEAMS_COLLECTION = "Teams";
export const FIRESTORE_COMPANY_PROFILE_COLLECTION = "CompanyProfiles";
export const FIRESTORE_COMPANY_PROFILES_STATUS_LOG_COLLECTION =
  "CompanyProfilesStatusLog";
export const FIRESTORE_COMPANY_PROFILE_METRICS_COLLECTION =
  "CompanyProfileMetrics";
export const FIRESTORE_CANDIDATE_PROFILES_COLLECTION = "CandidateProfiles";
export const FIRESTORE_CANDIDATE_PROFILES_METRICS_COLLECTION =
  "CandidateProfileMetrics";
export const FIRESTORE_APPLICATIONS_COLLECTION = "Applications";
export const FIRESTORE_PROMOTION_REQUESTS_COLLECTION = "PromotionRequests";
export const FIRESTORE_JOB_ALERT_PREFERENCES_COLLECTION = "JobAlertPreferences";

export const FIRESTORE_APP_MODE_DOCUMENT_ID = "helloradiusAppMode";
export const FIRESTORE_APP_MODE_EMPLOYER_ID = "employerMode";

export const FIRESTORE_SAVED_LOCATIONS_SUB_COLLECTION = "savedLocations";

// mirror on server if used
export const LOG_STATUS_INACTIVE = "Inactive";
export const LOG_STATUS_ACTIVE = "Active";
export const LOG_STATUS_SERVICE_EDITED = "Edited (resubmitted for review)";
export const LOG_STATUS_JOB_PROMOTED_SOCIALS = "Promoted on social media";

export const FIRESTORE_DOCUMENT_FIELDS = {
  users: {
    employer: {
      isAllowHideLocation: "isAllowHideLocation",
      billingAddress: "billingAddress",
      companyProfileId: "companyProfileId",
    },
    jobSeeker: {
      candidateProfileId: "candidateProfileId",
    },
  },
  coupons: {
    isUsed: "isUsed",
  },
  candidateProfileMetrics: {
    views: "views",
  },
};

export const LOG_ERROR_CODES = {
  signUpEmployer: 1,
  signUpJobSeeker: 2,
  signUpSocialLogin: 3,
  verifyAccount: 4,
  completeSignUp: 5,
  postJobForm: 6,
  companyPromotionFeaturedLogo: 7,
  adminReviewJob: 8,
  stripeCustomCheckout: 9,
  stripeCheckoutSession: 10,
  toggleJobActiveInactive: 11,
  editJob: 12,
  locationPlaceInput: 13,
  adminTopUp: 14,
  stripeInvoice: 15,
  companyProfiles: 16,
  adminReviewCompanyProfile: 17,
  candidateProfiles: 18,
  subscriptions: 19,
  profileSuggestions: 20,
};

export const QUERY_CODES = {
  getAppMode: 1,
  listenToJobSeekerSavedJobsFromFirestore: 2,
  listenToPromotionCompanyFeaturedLogosFromFirestore: 3,
  listenToAdminUnderReviewPaidJobsFromFirestore: 4,
  listenToAdminExpiredJobsFromFirestore: 5,
  listenToAdminPaidFeaturedCompanyLogosFromFirestore: 6,
  listenToAdminRequestDeleteAccounts: 7,
  listenToEmployerPaidJobsFromFirestore: 11,
  listenToEmployerDraftJobsFromFirestore: 12,
  listenEmployerPaidCompanyFeaturedLogos: 13,
  fetchKeywordFilterJobsFromFirestore: 14,
  fetchIndustryFilterJobsFromFirestore: 15,
  fetchJobTypeFilterJobsFromFirestore: 16,
  fetchKeywordAndIndustryFilterJobsFromFirestore: 17,
  fetchKeywordAndJobTypeFilterJobsFromFirestore: 18,
  fetchIndustryAndJobTypeFilterJobsFromFirestore: 19,
  fetchKeywordAndIndustryAndJobTypeFilterJobsFromFirestore: 20,
  listenToSponsoredJobsFromFirestore: 21,
  listenToJobUsingRefFromFirestore: 22,
  listenToJobViewCountFromFirestore: 23,
  fetchSimilarFeaturedJobsFromFirestore: 24,
  fetchSimilarSponsoredJobsFromFirestore: 25,
  listenToJobFromFirestore: 26,
  getUserAccount: 28,
  listenToServiceStatusLogFromFirestore: 29,
  listenEmployerFreeCompanyFeaturedLogos: 33,
  listenToAdminFreeFeaturedCompanyLogosFromFirestore: 34,
  listenToEmployerFreeJobsFromFirestore: 35,
  listenToAdminUnderReviewFreeJobsFromFirestore: 36,
  listenToRecentlyAddedJobsFromFirestore: 38,
  listenToFeaturedCompanyLogoFromFirestore: 39,
  listenToEmployerCouponsFromFirestore: 40,
  listenToAdminExpiredCompanyLogosFromFirestore: 41,
  getEmployerMode: 42,
  listenToAdminCompanyProfilesFromFirestore: 44,
  listenToCompanyProfileFromFirestore: 45,
  listenToCompanyUsingRefFromFirestore: 46,
  listenToCompanyJobsFromFirestore: 47,
  listenToCompanyProfilesFromFirestore: 48,
  listenToCountrySponsoredJobsFromFirestore: 49,
  listenToCompanyMetrics: 50,
  fetchCompanyUsingRefFromFirestore: 51,
  listenToDocFromFirestore: 52,
  listenToJobSeekerApplications: 53,
  listenToJobApplications: 54,
  listenToEmployerJobApplications: 55,
  listenToAdminPromotionRequestsFromFirestore: 56,
  listenToJobSeekerJobAlertPreferencesFromFirestore: 57,
  listenToCandidateProfile: 58,
  listenToCandidateProfileMetrics: 59,
};
